import { formatMonthAndYear, priceFormatter, Table, Text } from '@foradevelopment/fora-ui';
import { ReportedPayrollViewModel } from '@fora-monorepo/employer-my-pages-common/types';

import { formatEmployeeId } from '../../../common/utils';

type PayHistoryListTableRowProps = {
  payHistory: ReportedPayrollViewModel;
  isInitiallyExpanded?: boolean;
  testId: string;
};

export const PayHistoryTableRow = ({ payHistory, testId }: PayHistoryListTableRowProps) => {
  return (
    <Table.Row isInitiallyExpanded={false} testId={testId}>
      <Table.Cell>
        <Text> {payHistory.organizationName} </Text>
      </Table.Cell>
      <Table.Cell textAlign={'left'}>
        <Text> {formatEmployeeId(payHistory.employeeId)} </Text>
      </Table.Cell>
      <Table.Cell>
        <Text> {payHistory.firstName} </Text>
      </Table.Cell>
      <Table.Cell>
        <Text> {payHistory.lastName} </Text>
      </Table.Cell>
      <Table.Cell>
        <Text>{formatMonthAndYear(new Date(payHistory.payMonth))} </Text>
      </Table.Cell>
      <Table.Cell textAlign="right">
        <Text> {priceFormatter(Number(payHistory.payAmount))} kr </Text>
      </Table.Cell>
    </Table.Row>
  );
};
